var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-search"},[_c('GlobalSearchHeader'),_vm._v(" "),_c('GlobalSearchFilters'),_vm._v(" "),_c('GlobalSearchAlert'),_vm._v(" "),_c('GlobalSearchSubFilters'),_vm._v(" "),_c('GlobalSearchResults')],1)}
var staticRenderFns = []

export { render, staticRenderFns }